export default "__VITE_ASSET__C5sGoXI3__"